module.exports = __webpack_public_path__ + "static/media/offerBg.94cd8e5c.png";